import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { WorkspaceProductSlice } from '../../../../forms/types'
import { workspaceProductSliceFromDTO } from './api/mapper'
import { GET_WORKSPACE_FOR_FORM } from './api/query'
import { Data, Variables } from './api/types'
import { UseGetWorkspaceProduct, UseGetWorkspaceProductProps } from './types'

export const useGetWorkspaceProduct = ({
  id,
  product,
}: UseGetWorkspaceProductProps): UseGetWorkspaceProduct => {
  const [workspaceProduct, setWorkspaceProduct] = useState<WorkspaceProductSlice>()

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { node: workspace } = data

      if (workspace && product) {
        setWorkspaceProduct(workspaceProductSliceFromDTO(workspace, product))
      }
    },
    options: {
      enabled: id !== undefined && product !== undefined,
    },
    query: GET_WORKSPACE_FOR_FORM,
    variables: { id: id! },
  })

  return { loading, workspaceProduct }
}
